import { gql } from '@apollo/client';

// fragment
import { ASSIGNMENT_FRAG } from '../../fragments';

export const GET_ASSIGNMENT_LIST = gql`
  ${ASSIGNMENT_FRAG}
  query SkWeb_AssignmentList(
    $username: String
    $schoolId: ID
    $classroomId: ID
    $assignerId: ID
    $dateFrom: DateTime
    $dateTo: DateTime
    $page: Int
    $pageSize: Int
    $sortBy: String
    $order: String
  ) {
    assignmentList(
      username: $username
      schoolId: $schoolId
      classroomId: $classroomId
      assignerId: $assignerId
      dateFrom: $dateFrom
      dateTo: $dateTo
      page: $page
      pageSize: $pageSize
      sortBy: $sortBy
      order: $order
    ) {
      data {
        ...AssignmentFrag
        startDate
        homeworks {
          id
          isFinished
          doneDate # some date is null on DB
        }
      }
      totalCount
    }
  }
`;
